/**
 * DER HEUTIGE KALENDERTAG -- in der Zeitzone des Benutzers.
 *
 * `new Date().toISOString().slice(0, 10)` liefert den UTC-Tag. Zwischen
 * Mitternacht und ein bzw. zwei Uhr deutscher Zeit ist das noch GESTERN --
 * ein „gültig ab heute" wäre dann einen Tag zu früh datiert. Für ein
 * Gültigkeitsdatum zählt der Tag, den der Benutzer auf dem Kalender sieht.
 */
export function heuteLokal(): string {
  const d = new Date();
  const zwei = (n: number): string => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`;
}
